import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Transaction } from '../../../models/transaction';
import {CURRENCIES} from "../../../../assets/strings/translations";

@Component({
  selector: 'app-transaction',
  templateUrl: './transaction.component.html',
  styleUrls: ['./transaction.component.scss']
})
export class TransactionComponent  implements OnInit{
  constructor() { }

  iva: any;
  mobile:boolean;

  @Input() transaction: Transaction;
  @Input() orderID: string;

  hideReference= false;

  ngOnInit() {
    this.setMobile(window.innerWidth);
    this.hideReference = this.transaction.ORDER_CURRENCY === CURRENCIES.CRC;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    let width:number = event.target.innerWidth;;
    this.setMobile(width);
  }
  setMobile(width:number){
    this.mobile =width<768;
  }

}
